var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bar-page"},[_c('Header'),_c('SmoothScroll',[_c('PageTitle',{attrs:{"pageTitle":'ჟუჟუნას ბარი',"titleColor":'white',"bgColor":'#F49CB8'}}),_c('HistoryBlockBar'),_c('Configurator'),_c('Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }